import * as yup from "yup";

export const loginSchema = yup.object({
  username: yup
    .string()
    .trim()
    .required("Username is required")
    .min(3, "Username must be at least 3 characters")
    .max(100, "Username must be at most 100 characters"),
  password: yup.string().required("Password is required").min(1, "Password is required"),
});

export const loginInitialValues = {
  username: "",
  password: "",
};
